import axios, { AxiosPromise } from 'axios';
import { DownloadRequest } from '@/shared/model/download-request.model';
import { FirmaStatistik, StatistikCiteria } from '@/shared/model/statistik-citeria.model';

export default class BuchhaltungService {
  public async getStatistic(statistikCriteria: StatistikCiteria): Promise<FirmaStatistik> {
    return new Promise<FirmaStatistik>((resolve, reject) => {
      axios
        .post(`api/firmaStatistik`, statistikCriteria)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public async downloadSammelPDF(ids): Promise<string> {
    let filename = null;
    await axios.post(`api/downloadSammelRechnung`, ids, { responseType: 'blob' }).then(res => {
      filename = res.headers['content-disposition'];
      filename = filename.substr(filename.indexOf('=') + 1);

      const fileURL = window.URL.createObjectURL(new Blob([res.data]));
      const fileLink = document.createElement('a');

      fileLink.href = fileURL;
      fileLink.setAttribute('download', filename);
      document.body.appendChild(fileLink);

      fileLink.click();
    }).catch(err => {
      return err;
    });
    return filename;
  }

  public async downloadPDF(downloadRequest: DownloadRequest, force: boolean): Promise<string> {
    let filename = null;
    await axios.post(`api/downloadRechnung/${force}`, downloadRequest, { responseType: 'blob' }).then(res => {
      filename = res.headers['content-disposition'];
      filename = filename.substr(filename.indexOf('=') + 1);

      const fileURL = window.URL.createObjectURL(new Blob([res.data]));
      const fileLink = document.createElement('a');

      fileLink.href = fileURL;
      fileLink.setAttribute('download', filename);
      document.body.appendChild(fileLink);

      fileLink.click();
    }).catch(err => {
      return err;
    });
    return filename;
  }

  public async deleteFile(filename) {
    await axios.post('api/downloadDelete', filename);
  }
}
